import { LanguageSelection } from "component_old/macro/input/LanguageSelection"
import { S_DesktopOnly } from "component_old/micro/responsive/responsive"
import { EColors } from "libs/style/styling"
import React from "react"
import styled from "styled-components/macro"

export const FooterEnd = (): JSX.Element => {
  return (
    <S_Wrap>
      <S_FooterEnd>
        <S_LanguageSelection />
        <S_Content>
          <span>© 2024 Mapheim AS</span>
          <S_DesktopOnly>
            <S_Circle />
          </S_DesktopOnly>
          <span>Org. 929542681</span>
          <S_DesktopOnly>
            <S_Circle />
          </S_DesktopOnly>
          <span>Krambugata 2, 7011 Trondheim, Norway</span>
        </S_Content>
      </S_FooterEnd>
    </S_Wrap>
  )
}

const S_Wrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export const S_FooterEnd = styled.div`
  width: 100%;
  padding: 20px 20px 5px 20px;
  background-color: #101747;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  @media only screen and (min-width: 1260px) {
    padding: 25px;
  }
`

const S_Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  span {
    color: ${EColors.WHITE};
    font-size: 13px;
    display: block;
    margin: 0 0 15px 0;
  }
  @media only screen and (min-width: 1260px) {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    max-width: 1260px;
    span {
      margin: 0 10px;
      font-size: 15px;
    }
  }
`

const S_Circle = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #676e9b;
  margin: 0 10px;
`

const S_LanguageSelection = styled(LanguageSelection)`
  margin: 0px 0 20px 0;
  @media only screen and (min-width: 1260px) {
    margin: 10px 0 35px 0;
  }
`
